module.exports = __webpack_public_path__ + "img/coupon-4.1ab73db7.png";